import React from 'react';
import { PaymentReceiptData } from '../../api/documents';

interface PrintablePaymentReceiptProps {
  data: PaymentReceiptData;
}

/**
 * Printable payment receipt component
 * Optimized for browser printing with clean print styles
 */
export const PrintablePaymentReceipt: React.FC<PrintablePaymentReceiptProps> = ({ data }) => {
  return (
    <div className="receipt-content bg-white">
      <div className="p-8 max-w-[148mm] mx-auto">
        {/* Header */}
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold mb-1">PHIẾU THU</h1>
          <p className="text-sm text-gray-600">Payment Receipt</p>
        </div>

        {/* Receipt Info */}
        <div className="text-right mb-4 text-sm">
          <div className="mb-1">
            <strong>Số:</strong> {data.receiptNumber}
          </div>
          <div>
            <strong>Ngày:</strong> {data.date}
          </div>
        </div>

        {/* Divider */}
        <hr className="border-gray-800 my-4" />

        {/* Content */}
        <div className="space-y-2 mb-6">
          <div className="flex">
            <span className="w-32 font-normal">Điểm lấy hàng:</span>
            <span className="flex-1">{data.trip.pickup}</span>
          </div>
          <div className="flex">
            <span className="w-32 font-normal">Điểm giao hàng:</span>
            <span className="flex-1">{data.trip.delivery}</span>
          </div>
          <div className="flex">
            <span className="w-32 font-normal">Ngày chuyến:</span>
            <span className="flex-1">{data.trip.date}</span>
          </div>
          <div className="flex">
            <span className="w-32 font-normal">Xe:</span>
            <span className="flex-1">{data.trip.vehicle}</span>
          </div>
          <div className="flex">
            <span className="w-32 font-normal">Phương thức:</span>
            <span className="flex-1">{data.method}</span>
          </div>
        </div>

        {/* Amount */}
        <div className="text-center my-6 p-4 bg-gray-100 rounded">
          <div className="text-base font-bold mb-1">Số tiền</div>
          <div className="text-2xl font-bold text-red-600">{data.amount}</div>
        </div>

        {/* Notes */}
        {data.notes && (
          <div className="my-4 p-3 bg-gray-50 border-l-4 border-gray-600">
            <div className="font-bold mb-1">Ghi chú:</div>
            <div className="text-sm text-gray-700">{data.notes}</div>
          </div>
        )}

        {/* Footer */}
        <div className="mt-12">
          <hr className="border-gray-800 mb-4" />
          <div className="flex justify-between">
            <div className="text-center w-1/2">
              <div className="font-bold mb-12 text-sm">Người lập</div>
              <div className="border-t border-gray-800 inline-block px-12 pt-1 text-xs text-gray-600">
                Chữ ký
              </div>
            </div>
            <div className="text-center w-1/2">
              <div className="font-bold mb-12 text-sm">Người nhận</div>
              <div className="border-t border-gray-800 inline-block px-12 pt-1 text-xs text-gray-600">
                Chữ ký
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
